import React, { forwardRef, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import "./erf_Printout.scss";
import { formatDate } from "../../../../common/Validations";

const ErfPrintout = forwardRef((props, ref) => {
  //   const appConfig = useSelector((state) => state?.app?.appConfig);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(props?.data);
  }, [props]);
  // console.log(">>data", data);

const totals = Array.isArray(data?.rentItems)
  ? data.rentItems.reduce(
      (acc, item) => {
        acc.totalOrderedQuantity += Number(item?.orderedQuantity || 0);
        acc.totalSellingPrice += Number(item?.sellingPrice || 0);
        return acc;
      },
      {
        totalOrderedQuantity: 0,
        totalSellingPrice: 0,
      }
    )
  : {
      totalOrderedQuantity: 0,
      totalSellingPrice: 0,
    };

const netTotal =  Number(totals?.totalSellingPrice) + Number(data?.cartage)

  return (
    <>
      <div ref={ref} className="formContainer mb-5 pb-5">
        {/* <!-- Header Image --> */}
        <div className="">
          <img
            src="/assets/img/medirent/printoutimage/contract_details.jpg"
            alt="Medical Equipment Header"
          />
        </div>

        {/* <!-- Top Section --> */}
        <div className="top-section">
          <div className="right"></div>
          <div className="right">
            <span className="mx-2">
              <sppan>Date:</sppan>{" "}
              <span className="fw-bold">{formatDate(data?.createdAt)} </span>
            </span>
            <span>Erf No.</span>{" "}
            <span className="fw-bold">{data?.documentNumber}</span>
          </div>
        </div>

        {/* <!-- Customer Information --> */}
        {/* <div className="customer-info">
            <table>
                <tr>
                    <td>Patient's Name : M/s./Ms/Mrs./Mr :</td>
                    <td><strong>SAHIL VERMA</strong></td>
                    <td style={{textAlign: "right"}}>PAN Card No. :</td>
                </tr>
                <tr>
                    <td>Billing Address :</td>
                    <td colspan="2">B176 sainik nagar near nawada metro station</td>
                </tr>
                <tr>
                    <td>Delivery Address :</td>
                    <td colspan="2">B176 SAINIK NAGAR NEAR NAWADA METRO STATION</td>
                </tr>
            </table>
        </div> */}
        {/* <!-- Contract Title --> */}
        <div className="contract-title"> RENT CONTRACT</div>

        {/* <!-- Contract Content --> */}
        <div className="contract-section">
          <p>
            This contracts is made and executed at{" "}
            <strong>MEDIRENT SERVICES PVT. LTD.</strong>
          </p>
          <p>
            This day of <strong>{formatDate(data?.createdAt)}</strong> between
          </p>
          <p>
            M/s <strong>MEDIRENT SERVICES PVT. LTD.</strong> Plot No. 37,
            Electronic City, Sector-18, Gurugram, Haryana-122015 hereinafter
            called a <strong>COMPANY</strong> engaged in the business of renting
            various Medical Equipments / Product(s) &
          </p>
        </div>

        {/* <!-- Patient Information --> */}
        <div className="info-line">
          Patient's Name : M/s./Ms/Mrs./Mr :{" "}
          <strong>{data?.patientName}</strong>{" "}
          <span style={{ float: "right" }}>PAN Card No. : {data?.panNo}</span>
        </div>

        <div className="info-line">
          Billing Address :{" "}
          {/* <strong>B176 sainik nagar near nawada metro station</strong> */}
          <strong>{data?.billingAddress}</strong>
        </div>

        <div className="info-line">
          Delivery Address :{" "}
          <strong>B176 SAINIK NAGAR NEAR NAWADA METRO STATION</strong>
          <strong>{data?.deliveryAddress}</strong>
        </div>

        {/* <!-- Contract Description --> */}
        <div className="contract-section">
          <p>
            State- hereinafter called the <strong>Party</strong> interested to
            have the medical equipment/Product(s) on rent for the medical care
            of herself/ himself or (Name of the patient) which expression shall,
            unless repugnant to the context or meaning thereof, be deemed to
            mean and included his/her legal heirs, executors, administrators and
            legal representatives, the survivor or survivors, as the case may
            be.
          </p>
        </div>
        <p className="contract-section fw-bold">
          The details of products on Rent are as under :
        </p>
        {/* <!-- Products Table --> */}
        <table className="products-table">
          <thead>
            <tr>
              <th>Credit Note Status</th>
              <th>Product Code</th>
              <th>Barcode</th>
              <th>Product</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Days</th>
              <th>Qty.</th>
              <th>Amount</th>
            </tr>
          </thead>
          {/* <tbody>
            {data?.rentItems?.map((item, index) => (
              <tr key={index}>
                <td>{item.creditNoteStatus || "-"}</td>{" "}
                <td>{item.materialCode}</td> 
                <td>{item.barcode}</td> 
                <td>{item.materialDescription}</td> 
                <td>{formatDate(item.fromDate)}</td> 
                <td>{formatDate(item.toDate)}</td> 
                <td>{item.days}</td> 
                <td>{item.orderedQuantity}</td>
                <td>{item.netValue}</td> 
              </tr>
            ))}
            <tr className="total-row">
              <td colspan="7" className="text-end">
                Total
              </td>
              <td>{totals?.totalOrderedQuantity}</td>
              <td>{totals?.totalSellingPrice}</td>
              
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Total
              </td>

              <td>{totals?.totalSellingPrice}</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Cartage
              </td>

              <td>{data?.cartage}</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Installation Charges
              </td>

              <td>0</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Net Total
              </td>

              <td>Rs.{netTotal}</td>
            </tr>
          </tbody> */}
          <tbody>
  {data?.rentItems?.map((item, index) => (
    <tr key={index}>
      <td>{item.creditNoteStatus || "-"}</td>
      <td>{item.materialCode}</td>
      <td>{item.barcode}</td>
      <td>{item.materialDescription}</td>
      <td>{formatDate(item.fromDate)}</td>
      <td>{formatDate(item.toDate)}</td>
      <td>{item.days}</td>
      <td>{item.orderedQuantity}</td>
      <td>{item.netValue}</td>
    </tr>
  ))}
  <tr className="total-row">
    <td colSpan="7" className="text-end">Total</td>
    <td>{totals?.totalOrderedQuantity}</td>
    <td>{totals?.totalSellingPrice}</td>
  </tr>
  <tr className="total-row">
    <td colSpan="8" className="text-end">Cartage</td>
    <td>{data?.cartage}</td>
  </tr>
  <tr className="total-row">
    <td colSpan="8" className="text-end">Installation Charges</td>
    <td>0</td>
  </tr>
  <tr className="total-row">
    <td colSpan="8" className="text-end">Net Total</td>
    <td>Rs.{netTotal}</td>
  </tr>
</tbody>
        </table>

        {/* <!-- Financial Summary Below Table --> */}
        {/* <div className="financial-summary">
          <table>
            <tr>
              <td className="label">Cartage</td>
              <td className="value">1000</td>
            </tr>
            <tr>
              <td className="label">Installation Charges</td>
              <td className="value">0</td>
            </tr>
            <tr className="net-total">
              <td className="label">Net Total</td>
              <td className="value">Rs. 8000</td>
            </tr>
          </table>
        </div> */}

        {/* <!-- Terms and Conditions --> */}
        <div className="terms">
          <ol>
            <li>
              The company will provide the party medical equipment/product(s) on
              rent for personal use or for the patient for which this product is
              taken on rent.
              <ol>
                <li>
                  The PARTY will not further rent it out to other PARTY. It will
                  be used solely for the above mentioned patient.
                </li>
                <li>
                  In case the medical equipment is to be moved for the benefit
                  of the patient to a location other than on which it is
                  supplied, a prior approval of the COMPANY is to be taken.
                </li>
                <li>
                  The PARTY will allow the representatives of the COMPANY, to
                  check and service the medical equipment, as required from time
                  to time
                </li>
                <li>
                  The PARTY will return the medical equipment/product(s) by 12
                  noon at COMANY office/showroom/store on the day of expiry of
                  the contract, if not so minimum rent of one day will be
                  charged or company's representative picks up the equipment(s).
                </li>
              </ol>
            </li>
            <li>
              The party assures that the Medical equipment/Products(s) will be
              used with utmost care and diligence by SELF or a qualified medical
              staff as advised by the consulting Doctor. Any mal-functioning or
              otherwise of the working of the rented Medical
              equipment/Products(s) shall be informed to the COMANY immediately
              or as early as possible.
            </li>
            <li>
              The party agrees that the general health and the day-to-day well
              being of the patient is entirely the responsibility of the
              PARTY/User and COMPANY in no case will be held responsible for any
              eventuality such as injury, incapacity or death of the
              patient/user due to any reason whatsoever.
            </li>
            <li>
              The party agrees that the company is responsible only for making
              the equipment available and to provide efficient replacements in
              case of any malfunction. If, however, the malfunction causes any
              harm to the patient, the party shall not hold the company
              responsible for the same.
            </li>
            <li>
              The party acknowledges that it is aware of the ongoing issue with
              the Philips-Respironics respiratory devices, which is in the
              public domain. Further, the party acknowledges that it has taken
              the decision to use the product for the patient after
              weighing/discussing the risk/benefit analysis of the therapy with
              the treating physician.
            </li>
            <li>
              The PARTY will deposit Refundable Security in cash & cheque before
              hiring the Medical equipment/Product(s).
              <ol>
                <li>
                  The PARTY will pay advance rent as per the selected period. In
                  case the PARTY wants to extend the period the rent will be
                  paid again in advance before the expiry of the opted period.
                </li>
                <li>
                  The PARTY will decide the duration of rental plan and the
                  amount will be calculated accordingly, in case due to certain
                  reasons the equipment is returned before the expiry of decided
                  duration plan, the rent will be recalculated as per the
                  nearest effective rental plan of the Company. The difference
                  if any will be refunded or claimed as applicable
                </li>
                <li>
                  In case rent for extended period is not received within three
                  days, the amount due to the Company will be adjusted from the
                  cash security deposit towards rent / cost of the medical
                  equipment/Product(s).
                </li>
                <li>
                  The PARTY agrees to ensure sufficient funds in the Bank A/c,
                  in case of security amount is paid by Cheque.
                </li>
                <li>
                  All Payments in respect to transaction made by the PARTY with
                  the Company shall be payable at Head Office/Local Dealing
                  Offices/ Store. Drafts and cheques shall be drawn in favour of
                  the COMPANY and shall be payable at Delhi. Final/
                  Periodical/Termination of contract, settlement account in
                  respect of transactions between the COMPANY and the PARTY
                  shall be struck and finalized at COMPANY office or at local
                  dealing office at Delhi.
                </li>
              </ol>
            </li>
            <div className="">
              <img
                src="/assets/img/medirent/printoutimage/contract_details.jpg"
                alt="Medical Equipment Header"
              />
            </div>

            {/* <!-- Top Section --> */}
            <div className="top-section">
              <div className="right"></div>
              <div className="right">
                <span className="mx-2">
                  <sppan>Date:</sppan>{" "}
                  <span className="fw-bold">
                    {formatDate(data?.createdAt)}{" "}
                  </span>
                </span>
                <span>Erf No.</span>{" "}
                <span className="fw-bold">{data?.documentNumber}</span>
              </div>
            </div>

            <li>
              Delivery: Ex-office / Showroom / Store / Patient House.
              <ol>
                <li>
                  In case the PARTY wants to get the medical
                  equipment/Product(s) delivered at his place, To and Fro
                  charges for service / installation (as applicable) will be
                  paid by the PARTY in advance.
                </li>
              </ol>
            </li>
            <li>
              The product returned by the PARTY, after completion of the rental
              period, should be in the same condition in which it was delivered
              <ol>
                In case Medical equipment/Products is damaged by the PARTY
                during use or transportation or any reason what so ever the
                damages will be assessed by the COMPANY and paid by the PARTY in
                full and final.
              </ol>
            </li>
            <li>
              The COMPANY assures that the medical Equipment/Product(s) being
              supplied to the PARTY has been tested OK in all respects
            </li>
            <li>
              The PARTY is aware that certain medical equipments operate on
              electricity and others are manual in nature, in case there is any
              fault then PARTY will give sufficient time to the COMPANY for
              replacement and for making alternate arrangements. The COMPANY
              will try to replace medical equipment at the earliest and the
              maximum time for servicing / installation will be 24 hours. The
              PARTY will not claim any compensation from the COMPANY for this
              period.
            </li>
            <li>
              Miscellaneous
              <ol>
                <li>
                  The singular shall include the plural where the context so
                  admits and vice versa.
                </li>
                <li>
                  The masculine shall include the feminine and the neutral and
                  vice versa.
                </li>
                <li>
                  The masculine shall include the feminine and the neutral and
                  vice versa.
                </li>
                <li>
                  The COMPANY may send bill, or any other information to the
                  PARTY through Post/Courier/Electronic form or through any
                  other medium of communication.
                </li>
              </ol>
            </li>
            <li>
              All notices, correspondence or communications issued under this
              contract shall be a served in any one or more of the following
              modes of communications such notice or communication shall be
              served at the ordinary place of residence/residing
              address/ordinary business address of the PARTY to this contract
              such as: by hand delivery/by UPC/ regd.post/by telegram/ by
              affixing it on the door at the last residential or business
              address / by oral communication to the PARTY or on the last known
              telephone number or on the recording machine of such number.
            </li>
            <li>
              Jurisdiction: All disputes are subject to Delhi jurisdiction. IN
              WITNESS WHERE OF the parties here to have set their hands this day
              of
            </li>
          </ol>
        </div>

        <p className="contract-section text-end my-2">Signature of the party</p>

        <div className="declaration-container">
          <div className="contract-title">DECLARATION</div>

          <div className="d-flex justify-content-between info-line">
            <div>
              M/s./Ms./Mrs./Mr : <strong>{data?.patientName}</strong>
            </div>
            <div>
              ID Card No : <strong>{data?.panNo}</strong>
            </div>
          </div>

          <div className="info-line">
            <div className="full-width">
              Billing Address : <strong>{data?.billingAddress}</strong>
            </div>
          </div>

          <p className="declaration-text">
            I do hereby declare that what is stated above has been read
            carefully by me and I agree to follow the above said terms and
            conditions in totality and accordingly I make the payments. I also
            declare that the details (self) furnished are correct to the best of
            my knowledge.
          </p>

          <div className="signature-row">
            <div>
              <p className="mb-4">Signature of witness</p>
              <div className="mb-4">Name:</div>
              <div className="mb-4">Address:</div>
            </div>

            <div className="text-right">
              <p className="mb-4">Signature of the party</p>
              <div className="mb-4">Name:</div>
              <div className="mb-4">Address:</div>
            </div>
          </div>
        </div>

        <div className="">
          <img
            src="/assets/img/medirent/printoutimage/contract_details.jpg"
            alt="Medical Equipment Header"
          />
        </div>

        {/* <!-- Top Section --> */}
        <div className="top-section">
          <div className="right"></div>
          <div className="right">
            <span className="mx-2">
              <sppan>Date:</sppan>{" "}
              <span className="fw-bold">{formatDate(data?.createdAt)} </span>
            </span>
            <span>Erf No.</span>{" "}
            <span className="fw-bold">{data?.documentNumber}</span>
          </div>
        </div>

        <div className="contract-title"> DELIVERY / INSTALLATION RECEIPT</div>

        {/* <!-- Products Table --> */}
            <table className="products-table">
          <thead>
            <tr>
              <th>Credit Note Status</th>
              <th>Product Code</th>
              <th>Barcode</th>
              <th>Product</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Days</th>
              <th>Qty.</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {data?.rentItems?.map((item, index) => (
              <tr key={index}>
                <td>{item.creditNoteStatus || "-"}</td>{" "}
                {/* Credit Note Status */}
                <td>{item.materialCode}</td> {/* materialCode */}
                <td>{item.barcode}</td> {/* barcode */}
                <td>{item.materialDescription}</td> {/* materialDescription */}
                <td>{formatDate(item.fromDate)}</td> {/* fromDate */}
                <td>{formatDate(item.toDate)}</td> {/* toDate */}
                <td>{item.days}</td> {/* days */}
                <td>{item.orderedQuantity}</td> {/* orderedQuantity */}
                <td>{item.netValue}</td> {/* netValue */}
              </tr>
            ))}

            <tr className="total-row">
              <td colspan="7" className="text-end">
                Total
              </td>
              <td>{totals?.totalOrderedQuantity}</td>
              <td>{totals?.totalSellingPrice}</td>
              
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Total
              </td>

              <td>{totals?.totalSellingPrice}</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Cartage
              </td>

              <td>{data?.cartage}</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Installation Charges
              </td>

              <td>0</td>
            </tr>
            <tr className="total-row">
              <td colspan="8" className="text-end">
                Net Total
              </td>

              <td>Rs.{netTotal}</td>
            </tr>
          </tbody>
        </table>

        <div className="contract-container">
          <p className="dotted-line">
            From M/s <strong>MEDIRENT SERVICES PVT. LTD.</strong> through their
            service executive Sh :{" "}
            <strong>{data?.serviceExecutive || "GANESH SINGH"}</strong>
          </p>

          <p className="dotted-line">
            at my local address for my personal use/ patient Sh./Smt{" "}
            <strong>{data?.patientName}</strong>
          </p>

          <p className="paragraph">
            The above-mentioned Medical Equipment have been installed on our
            request & is in good running condition and I promise to maintain the
            property of the<span>COMPANY</span>.
          </p>

          <div className="two-column">
            <div>
              {" "}
              <span className="dotted-line">Date of Receipt </span>
            </div>
            <div className="right-align fw-bold">Signature of the Party/Patient</div>
          </div>

          <div className="two-column">
            <div>
              {" "}
              <span className="dotted-line">Time</span>{" "}
              <span className="line"></span>
            </div>
          </div>

          <div className="two-column dotted-line">
            <div>
              Patient Name : <strong>{data?.patientName}</strong>
            </div>
            <div>
              Patient's No : <strong>{data?.patientNo}</strong>
            </div>
          </div>

          <div className="two-column dotted-line">
            <div>
              Person Name (who is signing the contract) :
              <strong> {data?.signingPerson}</strong>
            </div>
            <div>
              Caregiver's No : <strong>{data?.caregiverNo}</strong>
            </div>
          </div>

          <p className="dotted-line">Relation with patient :</p>
          <p className="dotted-line">Comments if any :</p>
          <p className="dotted-line">Email id : {data?.email || "NA"}</p>

          <p className="fw-bold">Security Payment Details :</p>

          <div className="three-column dotted-line">
            <div>
              Total Security Amount : <strong>{data?.totalSecurity ?? 0}</strong>
            </div>
            <div>
              Recvd. Security Amount : <strong>{data?.receivedSecurity ?? 0 }</strong>
            </div>
            <div>
              Balance Security Amount : <strong>{data?.balanceSecurity ?? 0}</strong>
            </div>
          </div>

          <div className="three-column dotted-line">
            <div>Received Security Amount Mode : {data?.receivedMode ?? 0}</div>
            <div>Cash Security Amount : {data?.cashSecurity ?? 0}</div>
            <div>
              Remaining Security Amount : {data?.remainingSecurity ?? 0}
            </div>
          </div>

          <div className="three-column dotted-line">
            <div>Cheque No : {data?.chequeNo ?? "NA"}</div>
            <div></div>
            <div>Card Trans. No : {data?.cardTransNo ?? "NA"}</div>
          </div>

          <p className="fw-bold">Details of Balance Amount to be Collected</p>

          <div className="three-column dotted-line">
            <div>Balance Security Amount Mode : Cheque</div>
            <div>Cash Security Amount : 0</div>
            <div>
              Balance Security Amount : <strong>{data?.balanceSecurity ?? 0}</strong>
            </div>
          </div>

          <p className="dotted-line">
            Amount in words : <strong> </strong>
          </p>

          <div className="two-column dotted-line">
            <div>Cheque Date :</div>
            <div>Name of bank :</div>
          </div>

          <p className="dotted-line">
            In Favour of <strong>MEDIRENT SERVICES PVT. LTD.</strong>
          </p>

          <div className="three-column dotted-line">
            <div>
              (A) Rent : <strong>{netTotal}</strong>
            </div>
            <div>
              (B) Cartage : <strong>{data?.cartage}</strong>
            </div>
            <div>
              (C) Installation Charges : <strong>0</strong>
            </div>
          </div>

          <p className="right-align dotted-line">(A+B+C) TOTAL :</p>

          <div className="three-column dotted-line">
            <div>Cash Receipt No. of Advance Amount :</div>
            <div>Vehicle Type :</div>
            <div>Vehicle No :</div>
          </div>

          <div className="fw-bold">Bill Details :</div>
          <div className="three-column dotted-line">
            <div>Relationship No:</div>
            <div>Bill No :</div>
            <div></div>
          </div>
        </div>

        {/* <!-- Footer URL --> */}
        {/* <div className="footer-url">
          03/02/2026, 17:57
          normadnd.com/(S(suhtwd00jehvrcifaqactmmr))/erf/MD/ERF/rentcontract.aspx?id=18384&salepoint=GANESH
          SINGH
          <br />
          https://normadnd.com/(S(suhtwd00jehvrcifaqactmmr))/erf/MD/ERF/rentcontract.aspx?id=18384&salepoint=GANESH
          SINGH 1/4
        </div> */}
      </div>
    </>
  );
});

export default ErfPrintout;
